import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelSubscription,
  checkSubscriptionStatus,
  getPlans,
  subcriptionSession,
} from "../../redux/actions/subscription";
import { centsToDollar, formatTime } from "../../constants/base";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { updateUser } from "../../redux/slices/authSlice";
import { toast } from "react-toastify";
import { getAuthUser } from "../../redux/actions/user";

const stripePromise = loadStripe(
  "pk_test_51OU7ghASsJ0wnE4xys0iRsneOcZzL3uiDsCETgEzWlOMVQtUYTyDOg6kxm9g7fbLNa4CEyKfmkk3KxSNXpNz9UwF00sqprn9lI"
);

const Subscription = ({ role }) => {
  const authUser = useSelector((state) => state.AuthSlice.user);

  console.log("authUser==================", authUser);
  const user = useSelector((state) => state.user.user);

  console.log("=====================================", user);

  const plans = useSelector((state) => state.subscriptions);
  const subscriptionStatus = useSelector(
    (state) => state?.subscriptions?.subscriptionStatus
  );
  const [selectedPlan, setSelectedPlan] = useState("");
  const [showModelData, setShowModelData] = useState(false);

  const [loadingPlanId, setLoadingPlanId] = useState(null);

  const currentDate = new Date();
  const subscriptionEndDate = new Date(user?.subscription?.end_date);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAuthUser(authUser?.id));
  }, []);


  const handleCheckout = async (id, interval) => {

    setLoadingPlanId(id);

    const data = {
      user_id: user?.id,
      price_id: id,
      customer_email: user?.email,
      type: interval,
      url: location.pathname,
    };

    const response = await dispatch(subcriptionSession(data));
    const stripe = await stripePromise;
    const { error } = await stripe.redirectToCheckout({
      sessionId: response.payload.data.data.session_id,
    });

    if (error) {
      console.error(error);
    }
  };

  // SUBSCRIPTION STATUS
  const checkSubscriptionStatusFunction = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get("session_id");

    if (sessionId) {
      const data = {
        session_id: sessionId,
      };

      console.log("data", data);

      const res = await dispatch(checkSubscriptionStatus(data));

      console.log("Subscription status", res);

      if (checkSubscriptionStatus.fulfilled(res)) {
        const storeRes = dispatch(updateUser(res?.payload?.data?.data));
        console.log("User Update", storeRes);
        navigate("/payment/success");

        // if (updateUser.fulfilled(storeRes)) {
        //   navigate("/payment/success");
        // } else {
        //   navigate("/payment/error");
        // }
      } else if (checkSubscriptionStatus.rejected(res)) {
        navigate("/payment/error");
      }
    }
  };

  useEffect(() => {
    checkSubscriptionStatusFunction();
  }, []);
  // SUBSCRIPTION STATUS

  const getPlansHandler = async (role) => {
    // if (selectedPlan) {
    await dispatch(getPlans(role));
    // }
  };

  useEffect(() => {
    getPlansHandler(role);
  }, [role]);

  if (plans?.loading) {
    return (
      <div className="text-center">
        <i
          style={{ fontSize: "22px" }}
          className="fa-solid fa-spinner fa-spin"
        ></i>
      </div>
    );
  }

  // CANCEL SUBSCRIPTION HERE
  const handleCancelSubscription = async () => {
    const data = {
      subscription_id: user?.subscription?.stripe_subscription_id,
    };

    console.log(data, "cancel subscripiton here")

    const res = await dispatch(cancelSubscription(data));

    if (cancelSubscription.fulfilled(res)) {
      toast.success("Subscription has been cancelled!");
      window.location.reload();
    } else if (cancelSubscription.rejected(res)) {
      toast.error("Something went wrong to cancel the subscription!!");
      window.location.reload();
    }

    // if (res?.payload?.status === 200) {
    //   // const storeRes = dispatch(updateUser(res?.payload?.data?.data))
    // } else {
    //   toast.error("there is an error to cancel the subscription");
    // }
  };
  // CANCEL SUBSCRIPTION HERE

  return (
    <>
      <div>
        <div className="subscripiton-plans-box">
          <div className="container">
            <div className="row">
              <div
                className={`col-md-4 mb-4 ${user?.subscription?.type === "free" ? "currentPlan-box" : ""
                  } ${user?.subscription?.type === "free" &&
                    subscriptionEndDate < currentDate
                    ? "show-disable-card"
                    : ""
                  } ${user?.subscription?.type !== "free" ? "show-disable-card" : ""
                  }`}
              >
                <div className={`subscription-card`}>
                  <h1>
                    30 Days{" "}
                    {user?.subscription?.type === "free" &&
                      subscriptionEndDate < currentDate
                      ? "(Free Trial Expired)"
                      : ""}
                  </h1>
                  <span>Free Trial</span>
                  <p>
                    Thank you for your interest in I-Sit Corp! We're excited to
                    offer you a 30-day free trial of our services. During this
                    trial period, you'll have full access to all features with no
                    cost or commitment. This is the perfect opportunity to
                    experience the value we bring firsthand. If you have any
                    questions or need assistance, feel free to reach out to our
                    support team. We're here to help!
                  </p>
                  <span className="current-plan">Current Plan</span>
                </div>
              </div>

              {/* onClick={() => setSelectedPlan(plan)} */}
              {plans?.data?.prices?.map((plan) => (
                <div
                  className={`col-md-4 mb-4 ${user?.subscription?.type === plan?.recurring?.interval
                    ? "currentPlan-box"
                    : ""
                    } ${plan?.recurring?.interval === "month" &&
                      user?.subscription?.type === "year"
                      ? "show-disable-card"
                      : ""
                    }`}
                >
                  <div className={`subscription-card`}>
                    <h1>
                      {plan?.recurring?.interval == "year" ? "365" : "30"} Days
                    </h1>

                    <span>${centsToDollar(plan?.unit_amount)}</span>

                    <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Blanditiis, est?
                    </p>

                    <span className="current-plan">Current Plan</span>

                    <div className="d-flex h-100 align-items-end">
                      {user?.subscription?.type === plan?.recurring?.interval ? (
                        user?.subscription?.status == "cancelled" ? (
                          <button
                            className="btn btn-primary me-2"
                            disabled={true}
                            style={{ width: "fit-content" }}
                          >
                            Cancelled
                          </button>
                        ) : (

                          <button
                            className="btn btn-primary me-2"
                            data-bs-toggle="modal" href="#exampleModalToggle3" role="button"
                            style={{ width: "fit-content" }}
                          >
                            Cancel Subscription
                          </button>
                        )
                      ) : (
                        <button
                          className="btn btn-primary"
                          style={{ height: "45px" }}
                          disabled={plans.subBtnLoading}
                          onClick={(e) =>
                            handleCheckout(plan?.id, plan?.recurring?.interval)
                          }
                        >
                          {loadingPlanId === plan?.id ? (
                            <i
                              style={{ fontSize: "22px" }}
                              className="fa-solid fa-spinner fa-spin"
                            ></i>
                          ) : (
                            "Subscribe"
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="row mt-3">
              <div className="col-md-12 text-center">
                <span><strong>Subscription Till:</strong> {formatTime(user?.subscription?.end_date)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" data-bs-backdrop="static" id="exampleModalToggle3" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2" tabindex="-1">
        <div className="modal-dialog modal-dialog-centered service-add-model">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="btn-close" id='close-btn-update-model-3' data-bs-dismiss="modal" aria-label="Close">
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>

            <div className="modal-body">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 mt-4">
                    <div className="full-name-box justify-content-center">
                      <h1>Confirm subscription cancellation?</h1>
                    </div>
                    <div className="justify-content-center d-flex mb-4 mt-4">
                      <button type="button" disabled={plans?.cancelBtnLoading} className="btn btn-danger me-2" onClick={handleCancelSubscription}>
                        {plans?.cancelBtnLoading ? (
                          <i
                            style={{ fontSize: "22px" }}
                            className="fa-solid fa-spinner fa-spin"
                          ></i>
                        ) : (
                          "Yes"
                        )}
                      </button>

                      <button type="button" id='close-btn-update-model-3' data-bs-dismiss="modal" aria-label="Close" className="btn btn-secondary">
                        No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Subscription;
